export default __webpack_public_path__ + "static/media/como-cadastrar-moca2.dad15e3f.svg";